import { env } from "../env";

export type VerificationStatus = "pending" | "approved" | "rejected" | "expired";
export type BetaStatus = "awaiting_deposit" | "proof_submitted" | "manual_review" | "approved" | "declined";
export type WhitelistDepositStatus = BetaStatus | "expired";

async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body && !(init.body instanceof FormData)) headers.set("Content-Type", "application/json");
  const response = await fetch(`${env.apiBaseUrl}${path}`, { ...init, headers, credentials: "include" });
  const body = await response.json().catch(() => ({})) as { error?: string } & T;
  if (!response.ok) throw new Error(body.error || "Une erreur est survenue. Réessayez plus tard.");
  return body;
}

export async function requestOtp(email: string) {
  return request<{ ok: true }>("/api/auth/request-otp", { method: "POST", body: JSON.stringify({ email }) });
}

export async function confirmOtp(email: string, code: string) {
  return request<{ ok: true }>("/api/auth/verify-otp", { method: "POST", body: JSON.stringify({ email, code }) });
}

export function createWhitelistApplication(input: Record<string, unknown>) {
  return request<{ id: string }>("/api/whitelist/application", { method: "POST", body: JSON.stringify(input) });
}

export function uploadVerification(stage: "front" | "back" | "selfie", photo: File, verificationId?: string) {
  const body = new FormData();
  body.set("stage", stage);
  body.set("photo", photo);
  if (verificationId) body.set("verification_id", verificationId);
  return request<{ verification_id: string; status: VerificationStatus; expires_at: string }>("/api/verification/upload", { method: "POST", body });
}

export function getVerificationStatus() {
  return request<{ status: VerificationStatus; expires_at: string; deposit?: { reference: string; status: WhitelistDepositStatus; wallet_address: string; expires_at: string } | null; googlePlayClosedTestUrl?: string | null }>("/api/verification/status");
}

export function submitWhitelistDepositProof(txHash: string, amount: string) {
  return request<{ status: "proof_submitted" }>("/api/whitelist/deposit/proof", { method: "POST", body: JSON.stringify({ txHash, amount }) });
}

export function createBetaApplication(input: Record<string, unknown>) {
  return request<{ reference: string; walletAddress: string; minimumDeposit: string }>("/api/beta/applications", { method: "POST", body: JSON.stringify(input) });
}

export function submitBetaProof(reference: string, txHash: string, amount: string) {
  return request<{ status: BetaStatus }>("/api/beta/proof", { method: "POST", body: JSON.stringify({ reference, txHash, amount }) });
}

export function getBetaStatus(reference: string) {
  return request<{ status: BetaStatus; walletAddress: string; googlePlayClosedTestUrl?: string | null }>(`/api/beta/status?reference=${encodeURIComponent(reference)}`);
}
